<div class="mbs-list-select">
  @if (showSearch) {
    <div class="form-group mbs-list-select_search">
      @switch (useAdvancedSearch) {
        @case (true) {
          <mbs-advanced-search
            [accessUrlQuery]="false"
            [data]="searchTemplates"
            [(ngModel)]="advancedSearchFilters"
            (search)="updateFilters($event)" />
        }

        @default {
          <mbs-input
            [label]="filterLabel"
            [placeholder]="placeholder"
            [type]="'accented'"
            [(ngModel)]="filterTerm"
            (change)="searchChangeHandler($event)" />
        }
      }
    </div>
  }

  @if (showTopControls) {
    <div class="mbs-list-select_controls">
      <div class="row align-items-center justify-content-between">
        @if (showTopControlsCheckbox) {
          <div class="col-auto mbs-list-select_controls-checkbox">
            @if (data?.length > 0) {
              <mbs-checkbox
                [checked]="checkedTop"
                [indeterminate]="indeterminateTop"
                [label]="topControlsLabel"
                (change)="topControlsCheckboxChangeHandler($event)" />
            }
          </div>
        }

        @if (topControlsDescription; as description) {
          <div class="col-auto mbs-list-select_controls-description">
            {{ description }}
          </div>
        }
      </div>
    </div>
  }

  <div
    [class.-invalid]="!mySelectedData.length && invalid"
    [class.-maxHeight]="maxHeight"
    [class.-showTopControls]="showTopControls"
    [class]="classesTable + '-wrapper'">
    <mbs-table
      [bindDisabledValues]="bindDisabledValues"
      [bindSelected]="bindSelected"
      [bordered]="bordered"
      [changeSortState]="changeSortState"
      [checkboxCellClass]="checkboxCellClass"
      [checkboxCellWidth]="checkboxCellWidth"
      [classesTable]="classesTable"
      [contentClass]="tableContentClass"
      [data]="filtered"
      [headers]="headers"
      [hover]="hover"
      [infiniteScroll]="infiniteScroll"
      [infiniteScrollDistance]="infiniteScrollDistance"
      [infiniteScrollLoading]="infiniteScrollLoading"
      [infiniteScrollThrottle]="infiniteScrollThrottle"
      [keepState]="keepState"
      [loaderType]="loaderType"
      [loading]="loading"
      [maxBufferPx]="maxBufferPx"
      [maxHeight]="maxHeight"
      [maxVirtualScrollItemSize]="maxVirtualScrollItemSize"
      [minBufferPx]="minBufferPx"
      [minVirtualScrollItemSize]="minVirtualScrollItemSize"
      [multipleSelect]="multipleSelect"
      [noDataMessage]="noDataMessage"
      [rowClasses]="rowClasses"
      [selectable]="selectable"
      [selectAllIgnoreDisabled]="selectAllIgnoreDisabled"
      [selectedItems]="mySelectedData"
      [selectOnlyOnCheckboxClick]="selectOnlyOnCheckboxClick"
      [selectRowClass]="selectRowClass"
      [showCheckboxes]="showCheckboxes"
      [showHeaders]="showHeaders"
      [size]="size"
      [striped]="striped"
      [templates]="tableTemplates?.toArray()"
      [tooltipForDisabledRow]="tooltipForDisabledRow"
      [virtualItemSize]="virtualItemSize"
      [virtualItemsNumber]="virtualItemsNumber"
      [virtualScrolling]="virtualScrolling"
      [virtualScrollItemSizeDivider]="virtualScrollItemSizeDivider"
      [virtualTemplateCacheSize]="virtualTemplateCacheSize"
      (changeSelected)="handleChangeItemChecked($event)"
      (scroll)="scroll.emit($event)"
      (scrolled)="scrolled.emit()"
      (scrolledIndexChange)="scrolledIndexChange.emit($any($event))"
      (scrollEnd)="scrollEnd.emit($event)"
      (sort)="sort.emit($event)" />
  </div>
</div>

<ng-template #topControlsLabel>
  <ng-template [ngTemplateOutlet]="prependTopControlsLabel?.template" />

  @if (topControlsLabelSelected) {
    <span>{{ selectedData?.length }}</span>
  }

  <ng-template [ngTemplateOutlet]="appendTopControlsLabel?.template" />
</ng-template>
